<template>
  <!-- <v-app id="app"> -->
    <div id="app">
      <router-view />

    </div>
  <!-- </v-app> -->
</template>
<script>


import {mapGetters} from 'vuex'

export default {
  name: "App",
  data() {
    return {
      account: undefined,
    };
  },

  computed:{
    ...mapGetters(['getLoggedAccounts',]),

    path(){
      return window.location.pathname
    }

  },
  async created() {
    this.$emitter.on(
      'login',
      function (account) {
        this.account = account;

        // Usuário que volta com a conta MSAL cacheada entra pela tela de login e
        // precisa do redirect (o SignIn do LoginForm já faz o push no login novo).
        if (this.$route.path === '/')
          this.$router.push("/batchproduction");
      }.bind(this),
    ),
      this.$emitter.on('logout', () => {
        this.account = undefined;
      });
  },
};
</script>


<style scoped>
@import url("./global.css");

#app {
  height: 100vh;
  width: 100%;
  font-family: "Open Sans", sans-serif;
}
.container__grid {
  grid-template: "grid_menu" "grid_main" "grid_footer";
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;

}

.container__grid__main {
  grid-area: "grid_main";
  margin-top: 2.5rem;
  background-color: var(--color-background);
}

.container__grid__menu {
  grid-area: "grid_menu";
  position: fixed;
  background-color: white;
  height: 2.5rem;
  width: 100%;
  z-index:1000;
}

</style>
